import { Injectable, Optional } from '@angular/core';
import { AllowedPlaces, Message, Messages } from '@models/messages';
import { AppConstants } from '@models/appConstants';
import { IonicMessageServiceProvider } from '@mob-providers/ionic-message-service/ionic-message-service';
import { of } from 'rxjs/observable/of';

@Injectable()
export class MessageService {
	private messageTypes = {
		e: 'error',
		s: 'success',
		i: 'info',
		w: 'warning'
	};

	constructor(
		@Optional() private ionMessageService: IonicMessageServiceProvider
	) {}

	/*
    messageService.showToaster('e_0', 'general');
    */

	public showToaster(
		messageCode: string,
		place: AllowedPlaces,
		value?: string
	) {
		const messageObj = this.getMessageToShow(messageCode, place, value);
		AppConstants.isBrowser
			? this.showToasterForBrowser(messageObj)
			: this.ionMessageService.showToaster(messageObj);
	}

	public showDefaultErrorMessage = ({ data, status }) => {
		if (
			data !== undefined &&
			(status >= 400 && status < 500) &&
			data.errorMessage
		) {
			this.showToaster('e_2', 'general', data.errorMessage);
		} else {
			this.showToaster('e_0', 'general');
		}
	};

	public showErrorFromBackend(
		title = 'Whoops, something has gone wrong!',
		value = 'Please contact customer support.'
	) {
		if (AppConstants.isBrowser) {
			toastr.error(value, title);
		} else {
			const messageObj = {
				messageType: 'e',
				title,
				text: value
			};

			this.ionMessageService.showToaster(messageObj);
		}
	}
	public showMessageFromBackend(
		messageType: string,
		title: string,
		text: string
	): void {
		if (messageType) {
			const messageObj = {
				messageType,
				title,
				text
			};
			this.showToasterForBrowser(messageObj);
		}
	}

	public getCorrectMessageType(status): string {
		let messageStatus;
		switch (status) {
			case 'ok':
				messageStatus = 's';
				break;
			case 'warning':
				messageStatus = 'w';
				break;
			//  This case is just added for future uses
			case 'info':
				messageStatus = 'i';
				break;
			case 'error':
				messageStatus = 'e';
				break;
			default:
				break;
		}
		return messageStatus;
	}

	public catchErrorFromBackend(error) {
		this.showErrorFromBackend(error.error.errorTitle, error.error.errorMessage);
		return of(null);
	}

	private getMessageToShow(messageCode: string, place: string, value?: string) {
		if (!messageCode || !place) {
			console.error('incorrect initial date');
			return;
		}

		const [messageType, codeNumber] = messageCode.split('_');

		const messObj: Message = Messages[place][messageType][codeNumber];

		if (!messObj) {
			console.error("Message doesn't found!");
		}

		const title: string = messObj.title;
		let text: string = messObj.text;

		if (value) {
			text = text.replace('{value}', value);
		}

		return { messageType, title, text };
	}

	private showToasterForBrowser(msgObject): void {
		try {
			const { messageType, title, text } = msgObject;

			toastr[this.messageTypes[messageType]](text, title);
		} catch (err) {
			toastr.error('Client side error.', 'Error');
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=cbiehorjf0u!./shared/services/helpers/message-service/message.service.ts